// eslint-disable-next-line no-unused-vars
import http from '@/core/http'

const state = {
}

const actions = {
  cadastrarAfiliado: async (_, payload) => {
    const result = await http.post(`afiliados/create`, payload)
    // if (!result.data.success) throw new Error(result.data.message)
    return Promise.resolve(result)
  },
  obterAfiliado: async (_, payload) => {
    const result = await http.get(`afiliados/view`, { params: payload })
    // if (!result.data.success) throw new Error(result.data.message)
    // commit('SET_AFILIADO', result.data.data)
    return Promise.resolve(result)
  },
}

const mutations = {
}

const getters = {
}

export default { namespaced: true, state, actions, mutations, getters }